class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.locale = this.dataset.locale || "en-US";
    this.currency = this.dataset.currency || "USD";
    this.productHandles = JSON.parse(localStorage.getItem("recently-viewed-products")) || [];

    // remove currently viewed product from the list
    const currentProductHandle = this.dataset.currentProduct;
    this.productHandles = this.productHandles.filter((item) => item !== currentProductHandle);
  }

  generateSrcset(imageUrl) {
    const widths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];
    let srcset = "";

    for (const width of widths) {
      const newUrl = imageUrl.replace(/(\.\w{3,4})$/, `_${width}$1`);
      srcset += `${newUrl} ${width}w, `;
    }

    // Add the original image url at the end
    srcset += `${imageUrl} ${widths[widths.length - 1]}w`;

    return srcset;
  }

  formatMoney(amount, currency, locale) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  createProductCard(product) {
    const productCard = document.createElement("div");
    productCard.classList.add("product-card");
    productCard.innerHTML = `
		  <a href="${product.url}" class="group">
			<div class="relative">
				<div class="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
					<img 
						src="${product.featured_image}" 
						srcset="${this.generateSrcset(product.featured_image)}" 
						class="h-full w-full object-cover object-center group-hover:opacity-75"
						alt="${product.title}"
						sizes="368px" />
				</div>
				<div class="mt-4 text-sm text-gray-700 text-h2">${product.title}</div>
				<p class="mt-1 text-lg font-medium text-gray-900">
					<span>${`${this.formatMoney(product.price / 100, this.currency, this.locale)} ${this.currency}`}</span>
					${
            product.compare_at_price
              ? `<span class="text-gray-400 ml-2 font-light"><s>${`${this.formatMoney(
                  product.compare_at_price / 100,
                  this.currency,
                  this.locale
                )} ${this.currency}`}</s></span>`
              : ""
          }
				</p>
			</div>
		  </a>
		`;
    return productCard.outerHTML;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const promises = this.productHandles.map((handle) =>
        fetch(`/products/${handle}.js`, { method: "GET" })
          .then((response) => response.json())
          .catch((err) => console.error("Fetch error:", err))
      );

      Promise.all(promises)
        .then((data) => {
          const products = data.map((product) => this.createProductCard(product));
          const grid = this.querySelector("[data-grid]");
          grid.innerHTML = products.join("");
          // const heading = this.getElementsByTagName("h2")[0];
          const heading = this.getElementsByClassName("related-products__heading")[0];
          heading.classList.remove("hidden");
        })
        .catch((err) => console.error("Promise.all error:", err));
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);
